module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/usuario-grupo/usuario-grupo.component.css
// module id = ./src/app/usuario-grupo/usuario-grupo.component.css
// module chunks = main